export default __webpack_public_path__ + "sort-by-order.png";